import { render } from "./WeeklyPoints.vue?vue&type=template&id=e4f25c52"
import script from "./WeeklyPoints.vue?vue&type=script&lang=js"
export * from "./WeeklyPoints.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/ff-website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__